// Copyright (c) Zammo Inc.
import React, { useState } from 'react';
import styled from 'styled-components';

import ButtonComp from '../buttons/Button';
import InputComp from '../inputs/Input';
import URLTooltip from '../Tooltip/URLTooltip';

const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: auto;
`;

const Input = styled(InputComp)`
  font-size: 14px;
  height: 35px;
  padding-top: 0;
  padding-bottom: 0;
  margin: 0 1rem;
`;

const Button = styled(ButtonComp)`
  font-size: 14px;
  height: 35px;
  padding-top: 0;
  padding-bottom: 0;
`;

interface Props {
  setURL: (value: string) => void;
}

const URLInput = ({ setURL }: Props) => {
  const [value, setValue] = useState('');

  const handleConfirm = () => {
    let url = value;
    if (url.startsWith('http://')) {
      url = url.replace('http://', 'https://');
    } else if (!url.startsWith('https://')) {
      url = 'https://' + url;
    }
    setURL(url);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleConfirm();
    }
  };

  return (
    <Container>
      <URLTooltip tooltipPosition="left" />
      <div style={{ marginLeft: '10px' }}>URL:</div>
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="https://"
        onKeyDown={handleKeyDown}
      />
      <Button type="button" onClick={handleConfirm}>
        OK
      </Button>
    </Container>
  );
};

export default URLInput;
